import dayjs from 'dayjs'
import { TimeRange } from 'features/systemLens'
import { formatDuration } from 'features/timeSeries'
import React from 'react'
import styled from 'styled-components'

import { ActiveTimeRangeModeTag } from './ActiveTimeRangeModeTag'

const DateSpan = styled.span`
  white-space: nowrap;
`

interface TimeRangeDisplayProps {
  fromTime: dayjs.Dayjs
  toTime: dayjs.Dayjs
  liveTail?: boolean
  timeRange: TimeRange
}

export const TimeRangeDisplay: React.FC<TimeRangeDisplayProps> = ({
  fromTime,
  toTime,
  liveTail,
  timeRange,
}) => {
  if (liveTail === true) {
    return (
      <>
        <DateSpan data-role='start-date'>
          {fromTime.format('MMM DD, YYYY HH:mm')}
        </DateSpan>
        <span data-role='separator'>&ndash;</span>
        <DateSpan data-role='end-date'>
          Now
          <ActiveTimeRangeModeTag timeRange={timeRange} liveTail={liveTail} />
        </DateSpan>
      </>
    )
  }

  return (
    <>
      <DateSpan data-role='start-date'>
        {fromTime.format('MMM DD, YYYY HH:mm')}
      </DateSpan>
      <span data-role='separator'>&ndash;</span>
      <DateSpan data-role='end-date'>
        {toTime.format('MMM DD, YYYY HH:mm')}{' '}
        <span data-role='duration'>({formatDuration(fromTime, toTime)})</span>
      </DateSpan>
      <ActiveTimeRangeModeTag timeRange={timeRange} liveTail={liveTail} />
    </>
  )
}
